export enum CsmsConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
}
